import { visit } from 'unist-util-visit';
/**
 * Ensure caption content is nested in a paragraph.
 *
 * This function is idempotent.
 */
export function captionParagraphTransform(tree) {
    visit(tree, 'caption', (node) => {
        var _a;
        if (node.children && ((_a = node.children[0]) === null || _a === void 0 ? void 0 : _a.type) !== 'paragraph') {
            node.children = [
                { type: 'paragraph', children: node.children },
            ];
        }
    });
}
export const captionParagraphPlugin = () => (tree) => {
    captionParagraphTransform(tree);
};
